(ns common.schema.entities.ai-job-enrichment.core
  "The durable record of one AI entity-enrichment job: a document the user
   dropped into a create flow is parsed into suggested field values the user
   resumes the create flow with. Lifecycle (pending -> processing ->
   completed/failed/token-exhausted) lives on :ai-job-enrichment/status; named in
   the ai-job-* family with the other AI job entities.

   System-controlled: created and advanced only by the enrichment endpoint and
   worker, never user-editable, and readable only by the requesting account or an
   admin."
  (:require
   [common.schema.entities.ai-job-enrichment.permissions :as permissions]
   [common.schema.entities.ai-job-enrichment.schema :as schema]))

(def entity-type-definition
  {:entity-type                  :entity.type/ai-job-enrichment
   :schema                       schema/schema
   :name                         {:en "AI enrichment job"}
   :plural                       {:en "AI enrichment jobs"}
   :icon                         :fa-robot
   :display-name-fn              (fn [{:keys [entity]}]
                                   (:ai-job-enrichment/label entity))
   :display-name/depends-on      [:ai-job-enrichment/label]
   :permissions                  {:creatable?   false
                                  :disableable? false}
   :entity/mcp-blacklisted?      true
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
